/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceOption
 */
export interface SourceOption {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the SourceOption interface.
 */
export function instanceOfSourceOption(value: object): value is SourceOption {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function SourceOptionFromJSON(json: any): SourceOption {
    return SourceOptionFromJSONTyped(json, false);
}

export function SourceOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceOption {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function SourceOptionToJSON(json: any): SourceOption {
    return SourceOptionToJSONTyped(json, false);
}

export function SourceOptionToJSONTyped(value?: SourceOption | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

